module.exports = __webpack_public_path__ + "img/heart.ff1dbde4.svg";